import React from 'react';

const stripBullet = (line) => line.replace(/^[•○]\s*/, '');

export const renderLegalContentBlock = (block, key) => {
    const lines = block.split('\n').filter((line) => line.trim().length > 0);
    const hasBullets = lines.some((line) => line.trimStart().startsWith('•'));
    const hasNumbered = lines.some((line) => /^\d+\.\s/.test(line.trim()));

    if (hasBullets && !hasNumbered) {
        const introLines = lines.filter((line) => {
            const trimmed = line.trimStart();
            return !trimmed.startsWith('•') && !trimmed.startsWith('○');
        });

        const items = [];
        lines.forEach((line) => {
            const trimmed = line.trimStart();
            if (trimmed.startsWith('•')) {
                items.push({ text: stripBullet(trimmed), subs: [] });
            } else if (trimmed.startsWith('○') && items.length) {
                items[items.length - 1].subs.push(stripBullet(trimmed));
            }
        });

        return (
            <div key={key} className="content-block">
                {introLines.map((intro, i) => (
                    <p key={`intro-${i}`} className="content-intro">{intro}</p>
                ))}
                <ul className="legal-list">
                    {items.map((item, i) => (
                        <li key={i}>
                            {item.text}
                            {item.subs.length > 0 && (
                                <ul className="legal-sublist">
                                    {item.subs.map((sub, j) => (
                                        <li key={j}>{sub}</li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    if (hasNumbered) {
        const elements = [];
        let currentItems = [];
        let currentHeading = null;

        const flushList = () => {
            if (currentHeading || currentItems.length) {
                const headingMatch = currentHeading?.match(/^(\d+)\.\s+(.*)$/);
                elements.push(
                    <div key={`sub-${elements.length}`} className="content-subsection">
                        {headingMatch && (
                            <h3 className="subsection-heading">
                                <span className="step-num">{headingMatch[1]}</span>
                                {headingMatch[2]}
                            </h3>
                        )}
                        {currentItems.length > 0 && (
                            <ul className="legal-list">
                                {currentItems.map((item, i) => (
                                    <li key={i}>{stripBullet(item)}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                );
                currentHeading = null;
                currentItems = [];
            }
        };

        lines.forEach((line) => {
            const trimmed = line.trim();
            if (/^\d+\.\s/.test(trimmed)) {
                flushList();
                currentHeading = trimmed;
            } else if (trimmed.startsWith('•') || trimmed.startsWith('○')) {
                currentItems.push(trimmed);
            } else {
                flushList();
                const isEmphasis = /class action waiver/i.test(trimmed);
                elements.push(
                    <p
                        key={`p-${elements.length}`}
                        className={isEmphasis ? 'content-emphasis' : undefined}
                    >
                        {line}
                    </p>
                );
            }
        });
        flushList();

        return <div key={key} className="content-block">{elements}</div>;
    }

    return <p key={key}>{block}</p>;
};

export const slugify = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
